export default __webpack_public_path__ + "static/media/Amplitude-RegularItalic.48c6800e.otf";